<script>
import TextAttributeDropdownWithQuantityShare from './TextAttributeDropdownWithQuantityShare';

export default {
    extends: TextAttributeDropdownWithQuantityShare,
    template: this,
    data() {
        return {
            warning: false,
            regions: [],
            text_context_attribute_values: [],
            config: {
                defaultDate: null,
                dateFormat: 'Y-m-d',
            },
        }
    },
    methods: {
        prepareRegionLabel(value) {
            if (_.isEmpty(this.regions)) {
                return '';
            }

            if (!_.isObject(value.region_id)) {
                return this.regions.find(item => item.id === value.region_id).text || ''
            }

            return value.region_id.text;
        },
        storeValueDropdown() {
            this.storeValueData.text_attribute_context_id = this.text_attribute_context_id;

            this.storeValueData.region_id = this.storeValueData.region
                ? this.storeValueData.region.id
                : null;

            this.storeValueData.text_attribute_value_id = this.storeValueData.text_attribute_value
                ? this.storeValueData.text_attribute_value.id
                : null;

            this.storeValueData.text_attribute_context_value_id = this.storeValueData.text_attribute_context_value
                ? this.storeValueData.text_attribute_context_value.id
                : null;

            this.storeValue();
        },
        updateDropdownValue() {
            this.updateValueData.text_attribute_context_id = this.text_attribute_context_id;

            this.updateValueData.region_id = this.updateValueData.region
                ? this.updateValueData.region.id
                : null;

            this.updateValueData.text_attribute_value_id = this.updateValueData.text_attribute_value
                ? this.updateValueData.text_attribute_value.id
                : null;

            this.updateValueData.text_attribute_context_value_id = this.updateValueData.text_attribute_context_value
                ? this.updateValueData.text_attribute_context_value.id
                : null;

            this.updateValue();
        },
        prepareUpdate(value) {
            value.region = this.regions.find(item => item.id === value.region_id);

            return this.selectToUpdate(value)
        }
    },
    computed: {
        headline() {
            return '<strong>' + (this.attribute.attribute_name ?? this.attribute.name) + '</strong>';
        }
    },
    mounted() {
        axios.get(window.Scoop.baseUrl + '/edito/region').then((response) => {
            this.regions = response.data
        })
        axios.get(window.Scoop.baseUrl + '/edito/context/LICENSE_MEDIUM').then((response) => {
            this.text_attribute_context_id = response.data.id;
            this.text_context_attribute_values = response.data.text_attribute_context_values;
        }).catch(e => {
            this.warning = true;
        });
    },
}
</script>
<style>
.mx-datepicker-popup {
    z-index: 9999;
}
</style>
<template>
    <div :class="[withCols ? 'col-lg-8': '']">
        <div class="panel panel-default">
            <div class="panel-heading">
                <span v-html="headline"></span> (<small>* optional</small>)
                <div class="pull-right">
                    <a @click="storeValueDropdown" v-if="!isLocked"><i
                        class="fa fa-save"></i></a>
                    <i class="pull-right fa fa-lock" v-if="isLocked"></i>
                </div>
            </div>
            <div class="panel-body">
                <div clas="row" v-if="warning">
                    <div class="alert alert-warning m-b-md">
                        The attribute context "LICENSE_MEDIUM" does not exist.
                    </div>
                </div>
                <div class="row">
                    <h5 class="col-md-3" v-text="__('scoop-os.attributes.license.row.region')">Region</h5>
                    <h5 class="col-md-3" v-text="__('scoop-os.attributes.license.row.license')">Lizenz</h5>
                    <h5 class="col-md-2" v-text="__('scoop-os.attributes.license.row.medium')">Medium</h5>
                    <h5 class="col-md-2" v-text="__('scoop-os.attributes.license.row.from')">Von*</h5>
                    <h5 class="col-md-2" v-text="__('scoop-os.attributes.license.row.till')">Bis*</h5>
                </div>

                <div v-for="value in values" class="row m-b-sm">
                    <div v-if="isLocked">
                        <div v-if="hasContext" class="col-md-4">
                            <input readonly type="text" class="form-control"
                                   :value="value.text_attribute_context_value ? value.text_attribute_context_value.context_label : ''">
                        </div>
                        <div :class="[hasContext ? 'col-md-4': 'col-md-7']">
                            <input readonly type="text" class="form-control" :value="value.text_attribute_value.text">
                        </div>
                        <div :class="[hasContext ? 'col-md-2': 'col-md-3']">
                            <div class="input-group m-b">
                                <input readonly type="text" class="form-control text-center"
                                       :value="value.share_in_percent">
                                <span class="input-group-addon">%</span>
                            </div>
                        </div>
                        <div class="col-md-2 text-center text-muted">
                            <i class="fa" :class="value.exists_yes_no ? 'fa-check-square-o' : 'fa-square-o'"
                               aria-hidden="true" style="font-size: 15px; margin: 10px 0 0 -8px;"></i>
                        </div>
                    </div>
                    <Lightbox
                        v-if="!isLocked"
                        :id="lightboxId(value.id)"
                        :headline="headline"
                        :large="true"
                    >
                        <div slot="open-template" @click="prepareUpdate(value)">
                            <div class="col-md-3">
                                <input type="text" class="form-control"
                                       :value="prepareRegionLabel(value)">
                            </div>
                            <div class="col-md-3">
                                <input type="text" class="form-control" :value="value.text_attribute_value.text">
                            </div>
                            <div class="col-md-2">
                                <input type="text" class="form-control"
                                       :value="value.text_attribute_context_value !== null ? value.text_attribute_context_value.context_label : ''">
                            </div>
                            <div class="col-md-2">
                                <input type="text" class="form-control" :value="value.date_from">
                            </div>
                            <div class="col-md-2">
                                <input type="text" class="form-control" :value="value.date_till">
                            </div>
                        </div>
                        <div slot="body" class="text-left">
                            <div class="row">
                                <h5 class="col-md-3">Region</h5>
                                <h5 class="col-md-3">Lizenz</h5>
                                <h5 class="col-md-2">Medium</h5>
                                <h5 class="col-md-2">Von*</h5>
                                <h5 class="col-md-2">Bis*</h5>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <v-select v-model="updateValueData.region" :options="regions"
                                              label="text"></v-select>
                                </div>
                                <div class="col-md-3">

                                    <v-select v-model="updateValueData.text_attribute_value" :options="options"
                                              label="text"></v-select>
                                </div>
                                <div class="col-md-2">

                                    <v-select v-model="updateValueData.text_attribute_context_value"
                                              :options="text_context_attribute_values"
                                              label="context_label"></v-select>
                                </div>
                                <div class="col-md-2">
                                    <flat-pickr class="form-control" ref="input" :config="config"
                                                v-model="updateValueData.date_from"/>
                                </div>
                                <div class="col-md-2">
                                    <flat-pickr class="form-control" ref="input" :config="config"
                                                v-model="updateValueData.date_till"/>
                                </div>
                            </div>
                        </div>
                        <div v-cloak slot="footer">
                            <div class="pull-left">
                                <button type="button" class="btn btn-danger" @click="deleteValue(value.id)"
                                        v-text="__('scoop-os.common.delete')"></button>
                            </div>
                            <button type="button" class="btn btn-white" data-dismiss="modal"
                                    v-text="__('scoop-os.common.close')"></button>
                            <button class="btn btn-primary" @click="updateDropdownValue">Update</button>
                        </div>
                    </Lightbox>
                </div>
                <div v-if="!isLocked" class="row">

                    <div class="col-md-3">
                        <v-select v-model="storeValueData.region" :options="regions"
                                  label="text"></v-select>
                    </div>
                    <div class="col-md-3">
                        <v-select v-model="storeValueData.text_attribute_value" :options="options"
                                  label="text"></v-select>
                    </div>
                    <div class="col-md-2">
                        <v-select v-model="storeValueData.text_attribute_context_value"
                                  :options="text_context_attribute_values"
                                  label="context_label"></v-select>
                    </div>
                    <div class="col-md-2">
                        <flat-pickr class="form-control" ref="input" :config="config"
                                    v-model="storeValueData.date_from"/>

                    </div>
                    <div class="col-md-2">
                        <flat-pickr class="form-control" ref="input" :config="config"
                                    v-model="storeValueData.date_till"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

